import React from 'react';

interface FreeTieItemCardProps {
	title: string;
	secondTitle?: string;
	description?: string;
	image: string;
	onPress: () => void;
}

const FreeTieItemCard = (props: FreeTieItemCardProps) => {
	return (
		<div
			className="freeTieItemCard"
			onClick={() => props.onPress()}
		>
			<img
				className={`freeTieItemCard__image`}
				src={`${process.env.PUBLIC_URL}/assets/images/freeTies/${props.image}.webp`}
				alt={props.image}
			/>
			<div className="freeTieItemCard__info">
				<div className="freeTieItemCard__info_title">
					<span>{props.title}</span>
					{
						props.secondTitle ? (
							<span>{props.secondTitle}</span>
						) : null
					}
				</div>
				{/*<div className="freeTieItemCard__info_description">
					<span>{props.description}</span>
				</div>*/}
			</div>
		</div>
	);
};

export default FreeTieItemCard;